import { IDisplayStatus } from '../graphql';

/**
 * Get display status from localStorage (client-side only)
 * Used for client-side components and effects
 */
export const getDisplayStatusFromStorage = (): IDisplayStatus => {
  if (typeof window !== 'undefined') {
    const savedPreviewMode = localStorage.getItem('admin-preview-mode');
    return savedPreviewMode === 'true' ? IDisplayStatus.Preview : IDisplayStatus.Live;
  }
  return IDisplayStatus.Live;
};

/**
 * Get display status from cookies (SSR compatible)
 * Used in getServerSideProps for server-side rendering
 */
export const getDisplayStatusFromCookies = (req: any): IDisplayStatus => {
  const previewCookie = req.cookies['admin-preview-mode'];
  return previewCookie === 'true' ? IDisplayStatus.Preview : IDisplayStatus.Live;
};

/**
 * Legacy function to maintain backward compatibility
 * Reads preview status from URL query parameters
 */
export const getDisplayStatusFromQuery = (context: any): IDisplayStatus => {
  const { preview } = context.query;

  if (preview === 'PREVIEW') {
    return IDisplayStatus.Preview;
  }

  return IDisplayStatus.Live;
};

/**
 * Set cookie for SSR synchronization
 * Call this on client-side when preview state changes
 */
export const setPreviewCookie = (isPreview: boolean): void => {
  if (typeof document !== 'undefined') {
    const maxAge = 86400; // 24 hours
    document.cookie = `admin-preview-mode=${isPreview}; path=/; max-age=${maxAge}`;
  }
};
